// --------------------------------------------
// Constants to be used in actions and reducers
// ---------------------------------------------
const PREFIX = 'KardiaRx.';

export const CCT_PATIENT_HISTORY_DATA_REQUEST = `${PREFIX}CCT_PATIENT_HISTORY_DATA_REQUEST`;
export const CCT_PATIENT_HISTORY_DATA_SUCCESS = `${PREFIX}CCT_PATIENT_HISTORY_DATA_SUCCESS`;
export const CCT_PATIENT_HISTORY_DATA_FAILURE = `${PREFIX}CCT_PATIENT_HISTORY_DATA_FAILURE`;
export const CCT_PATIENT_HISTORY_SELECTED_PATIENT = `${PREFIX}CCT_PATIENT_HISTORY_SELECTED_PATIENT`;
export const CCT_PATIENT_HISTORY_SELECTED_RECORDING = `${PREFIX}CCT_PATIENT_HISTORY_SELECTED_RECORDING`;

export const CCT_PATIENT_HISTORY_COMPLETED = `${PREFIX}CCT_PATIENT_HISTORY_COMPLETED`;
export const CCT_RESEND_EOS_REPORT = `${PREFIX}CCT_RESEND_EOS_REPORT`;

export const CCT_FETCH_EVENT_HISTORY_REQUEST = `${PREFIX}CCT_FETCH_EVENT_HISTORY_REQUEST`;
export const CCT_FETCH_EVENT_HISTORY_SUCCESS = `${PREFIX}CCT_FETCH_EVENT_HISTORY_SUCCESS`;
export const CCT_FETCH_EVENT_HISTORY_FAILURE = `${PREFIX}CCT_FETCH_EVENT_HISTORY_FAILURE`;

export const CCT_FETCH_EOS_REPORT_STATUS_REQUEST = `${PREFIX}CCT_FETCH_EOS_REPORT_STATUS_REQUEST`;
export const CCT_FETCH_EOS_REPORT_STATUS_SUCCESS = `${PREFIX}CCT_FETCH_EOS_REPORT_STATUS_SUCCESS`;
export const CCT_FETCH_EOS_REPORT_STATUS_FAILURE = `${PREFIX}CCT_FETCH_EOS_REPORT_STATUS_FAILURE`;



// WEBPACK FOOTER //
// ./src/views/state/KardiaRxCCTPatientHistory/types.js